/* ==========================================================================
   HOPE BASE ADVISORY LLC — SECTOR EXPERTISE TABS (100% 2026 PROFILE CHAPTER 14)
   ========================================================================== */

const sectorData = {
  health: {
    title: "Health Systems and Health Information",
    summary: "Disease registry design and operationalisation, health information system assessment, and evidence connecting epidemiological data to health financing decisions. Delivered in coordination with the Federal Ministry of Health and Human Services.",
    image: "/images/health-systems.jpg",
    tags: ["Multi-Disease Registries", "ICD-10 & ICD-O Coding", "TNM & WHO PEN Protocols", "DHIS2 Interoperability", "Fiscal Space Analysis"]
  },
  agriculture: {
    title: "Enterprise, Agribusiness and Skills Development",
    summary: "Training and advisory for producer groups, women’s groups, cooperatives and young people, designed for adult learners with mixed literacy and for groups that must keep functioning after the training ends.",
    image: "/images/agriculture-advisory.jpg",
    tags: ["Curriculum & Facilitator Guides", "Financial Literacy & Bookkeeping", "Climate-Smart Agribusiness", "Youth Digital Marketing", "Market Access Strategies"]
  },
  governance: {
    title: "Financial and Grant Management",
    summary: "Systems, controls and grant oversight built to survive donor audit. We work on the points where donor-funded institutions usually fail: source documentation, segregation of duties, and budgets that reconcile to workplans.",
    image: "/images/hero-consulting.jpg",
    tags: ["Financial Systems & Internal Controls", "Proposal Budgets & Forecasting", "Milestone Verification Packages", "Donor Compliance Review", "Grant Oversight to Closure"]
  },
  gis: {
    title: "GIS, Spatial Analysis and Technical Surveys",
    summary: "Spatial intelligence for infrastructure planning, land management, climate resilience and development investment, combining mapping and analysis with field survey capability.",
    image: "/images/gis-spatial.jpg",
    tags: ["GIS Mapping & Spatial Data", "Drone & Topographical Surveys", "Geodetic & Land Boundary", "Hydrographic Surveys", "Climate Baseline Studies"]
  }
};

export function initSectorTabs() {
  const tabs = document.querySelectorAll('.sector-tab');
  const titleEl = document.getElementById('sector-title');
  const summaryEl = document.getElementById('sector-summary');
  const imgEl = document.getElementById('sector-img');
  const tagsContainer = document.getElementById('sector-tags-container');

  if (!tabs.length || !titleEl || !summaryEl || !imgEl) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const sectorKey = tab.getAttribute('data-sector');
      const data = sectorData[sectorKey];

      if (data) {
        titleEl.textContent = data.title;
        summaryEl.textContent = data.summary;
        imgEl.src = data.image;
        imgEl.alt = data.title;

        if (tagsContainer) {
          tagsContainer.innerHTML = data.tags
            .map(tag => `<span class="pill-badge teal">${escapeHtml(tag)}</span>`)
            .join(' ');
        }
      }
    });
  });
}

function escapeHtml(str) {
  if (!str) return '';
  return String(str).replace(/[&<>"']/g, m => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  })[m]);
}
